// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qXN6E","title":"Header_title__2RdZ5","left":"Header_left__3Xg85","clinicName":"Header_clinicName__1Y2i6"};